import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Header from 'components/header';
import Footer from 'components/footer';

import LayoutVertical from '../layout-vertical';

import './style.css';

class LayoutPage extends Component {
  static Container = ({ children, className }) => {
    const customClassName = classNames('page-container', className);
    return (
      <LayoutVertical className={customClassName}>{children}</LayoutVertical>
    );
  };

  static Content = ({ children, className }) => {
    const customClassName = classNames('page-content', className);
    return <div className={customClassName}>{children}</div>;
  };

  static ContentFull = ({ children, className }) => {
    const customClassName = classNames('page-content-full', className);
    return <div className={customClassName}>{children}</div>;
  };

  render() {
    const { children, className, header, footer, userType, ...rest } = this.props;
    const customClassName = classNames('layout-page', className);
    return (
      <LayoutVertical className={customClassName} {...rest}>
        {header ? <Header userType={userType} /> : null}
        {children}
        {footer ? <Footer /> : null}
      </LayoutVertical>
    );
  }
}

LayoutPage.propTypes = {
  header: PropTypes.bool,
  footer: PropTypes.bool,
  children: PropTypes.node.isRequired,
  userType: PropTypes.string,
  className: PropTypes.string,
};

LayoutPage.defaultProps = {
  header: true,
  footer: true,
  userType: '',
  className: '',
};

export default LayoutPage;
